import { Container, Row, Col, Card, Button, ButtonGroup, Modal } from 'react-bootstrap';
import React, { useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import DeckManager from 'src/DeckManager';
import ImageModal from 'src/components/ImageModal';
import PrintConfirmationModal from 'src/components/PrintConfirmationModal';

const Deck = () => {
  const [modalPrintConfirmationShow, setModalPrintConfirmationShow] = React.useState(false);
  const [modalImageShow, setModalImageShow] = React.useState(false);
  const [modalImageSrc, setModalImageSrc] = React.useState("");
  // const [canvasShow, setCanvasShow] = React.useState(true);
  // const canvasRef = useRef(null);
  const navigate = useNavigate();
  const initialStates = {
    deck: [],
  }
  // Deck to display
  const [deck, setDeck] = React.useState(initialStates.deck);

  const goToMainPage = () => {
    navigate("/");
  }

  const addCard =(card, qty) => {
    if (DeckManager.addCardToDeck(card, qty)){
      setDeck(DeckManager.getCardsInDeck());
    }
  }

  const resetDeck = () => {
    localStorage.setItem("deck", JSON.stringify([]));
    setDeck([]);
  }

  const shareDeck = () => {
    // setCanvasShow(true);
    // generateDeckListImage();
    navigator.clipboard.writeText(DeckManager.export()).then(() => {
      alert("Copy Link สำเร็จแล้ว สามารถส่งต่อให้คนอื่นได้เลย!");
    }).catch((e) => {
      console.log(e);
    });
  }

  const shareDeck2 = () => {
    // setCanvasShow(true);
    // generateDeckListImage();
    navigator.clipboard.writeText(DeckManager.export2()).then(() => {
      alert("Copy Link สำเร็จแล้ว สามารถส่งต่อให้คนอื่นได้เลย! V2");
    }).catch((e) => {
      console.log(e);
    });
  }

  const openDeck2 = () => {
    // setCanvasShow(true);
    // generateDeckListImage();
    navigator.clipboard.writeText(DeckManager.export2()).then(() => {
      //alert(DeckManager.export2());
      navigate(DeckManager.export2open());
    }).catch((e) => {
      console.log(e);
    });

  }

  // const generateDeckListImage = () => {
  //   if (canvasRef.current !== null){
  //     const context = canvasRef.current.getContext('2d');
  //     const image = new Image();
  //     image.src = `images/cards/starter/001.jpg`;
  //     image.onload = () => {
  //       context.drawImage(image, 0, 0, canvasRef.current.width / 5, canvasRef.current.height);
  //     };
  //   }
  // }

  // Run on page load
  useEffect(() => {
    setDeck(DeckManager.getCardsInDeck());
  }, []);

  const CardList = (props) => {
    return (
      <Row className="deck">
        {deck.map(card =>
          card.type === props.type &&
          <Col key={`${card.pack}-${card.id}`} xs={12} sm={12} md={6} lg={3}>
            <Card className="card-list" key={card.pack + " " + card.id}>
              <Row>
                <Col xs={3} sm={3}>
                  <Card.Img
                    src={`images/cards/${card.pack.toLowerCase()}/${card.id}.jpg`} 
                    onClick={() => {
                      setModalImageSrc(`images/cards/${card.pack.toLowerCase()}/${card.id}.jpg`);
                      setModalImageShow(true);
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src=`images/cards/unknown.jpg`;
                  }}/>
                </Col>
                <Col className="card-info" xs={9} sm={9}>
                  <Card.Title>[{ card.pack + " " + card.id }] { card.name }</Card.Title>
                  <ButtonGroup className="d-flex">
                    <Button variant="secondary" className="plus-minus-button" onClick={(event) => addCard(card, -1)}>-</Button>
                    <Button variant="">{DeckManager.getNumberOfCardInDeck(card)} ใบ</Button>
                    <Button variant="secondary" className="plus-minus-button" onClick={(event) => addCard(card, 1)}>+</Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Card>
          </Col>
        )}
      </Row>
    );
  }

  return (
    <Container fluid className="bg">
      <PrintConfirmationModal
        deck={deck}
        show={modalPrintConfirmationShow}
        onHide={() => setModalPrintConfirmationShow(false)}
      />
      <ImageModal
        show={modalImageShow}
        src={modalImageSrc}
        onClick={() => setModalImageShow(false)}
        onHide={() => setModalImageShow(false)}
      />
      <h1 className="text-center">Deck Manager</h1>
      <Row className="deck-manager-buttons">
        <Col xs={12} sm={6}>
          <ButtonGroup className="d-flex">
            <Button variant="dark" onClick={(event) => resetDeck()}>รีเซ็ตเด็ค</Button>
          </ButtonGroup>
        </Col>
        <Col xs={12} sm={6}>
          <ButtonGroup className="d-flex">
            <Button variant="secondary" onClick={(event) => goToMainPage()}>กลับไปหน้าหลัก</Button>
          </ButtonGroup>
        </Col>
        <Col xs={12} sm={6}>
          <Row className="deck-manager-buttons">
            <Col xs={12} sm={6}>
              <ButtonGroup className="d-flex">
                <Button variant="primary" onClick={(event) => shareDeck()}>Copy Link เพื่อแชร์เด็ค</Button>
            </ButtonGroup>
            </Col>
            <Col xs={12} sm={6}>
              <Row className="deck-manager-buttons">
                <Col xs={12} sm={6}>
                  <ButtonGroup className="d-flex">
                    <Button variant="primary" onClick={(event) => shareDeck2()}>Copy Link V2</Button>
                </ButtonGroup>
                </Col>
                <Col xs={12} sm={6}>
                  <ButtonGroup className="d-flex">
                    <Button variant="primary" onClick={(event) => openDeck2()}>Open Link V2</Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={12} sm={6}>
          <ButtonGroup className="d-flex">
            <Button variant="success" onClick={(event) => setModalPrintConfirmationShow(true)}>ดาวน์โหลดไฟล์ Decklist</Button>
          </ButtonGroup>
        </Col>
      </Row>
      {/* { canvasShow && 
        <Row>
          <Col className='section' xs={12}>
          <canvas ref={canvasRef} />
          </Col>
        </Row>
      } */}
      <Row>
        <Col className='section' xs={12}>
          <h1>ซีล / Seal ({ deck.reduce((acc, {type, qty}) => type === "seal" ? acc + qty : acc, 0) } ใบ)</h1>
        </Col>
      </Row>
      <CardList type="seal" />
      <Row>
        <Col className='section' xs={12}>
          <h1>มิสติก / Mystic ({ deck.reduce((acc, {type, qty}) => type === "mystic" ? acc + qty : acc, 0) } ใบ)</h1>
        </Col>
      </Row>
      <CardList type="mystic" />
      <Row>
        <Col className='section' xs={12}>
          <h1>หัวใจ / Heart ({ deck.reduce((acc, {type, qty}) => type === "heart" ? acc + qty : acc, 0) } ใบ)</h1>
        </Col>
      </Row>
      <CardList type="heart" />
      <Row>
        <Col className='section' xs={12}>
          <h1>รวม Seal+Mystic = [{ deck.reduce((acc, {type, qty}) => type === "seal" || type === "mystic" ? acc + qty : acc, 0) } ใบ]</h1>
        </Col>
      </Row>
    </Container>
  );
}

export default Deck;